module.exports = __webpack_public_path__ + "static/media/agriculture.44a3e7f4.webp";